<template>
  <v-container>
    <v-select
      :items="sourceLevels"
      v-model="selectedSource"
      :rules="[v => !!v || $t('source_eval_required')]"
      solo
    ></v-select>
    <v-row>
      <v-col>
        <p>
          <span class="font-weight-bold">A.</span>
          {{ $t('source_evaluation_1') }}
        </p>
        <p>
          <span class="font-weight-bold">B.</span>
          {{ $t('source_evaluation_2') }}
        </p>
        <p>
          <span class="font-weight-bold">C.</span>
          {{ $t('source_evaluation_3') }}
        </p>
        <p>
          <span class="font-weight-bold">D.</span>
          {{ $t('source_evaluation_4') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'

export default {
  name: 'SourceEvaluation',
  data: vm => ({
    selectedSource: '',
    sourceLevels: maocData.sourceEvaluation
  }),
  methods: {
    getData: function () {
      return this.selectedSource
    },
    setData: function (data) {
      this.selectedSource = data
    }
  }
}
</script>
